// extracted by mini-css-extract-plugin
export default {"section":"jMcCO","sectionOpened":"WRTyR","icon":"stmkI","header":"_r9XX","headerInner":"vieD_","check":"pgjVW","title":"vqMse","inner":"np3wh"};